import React, { useState } from 'react';

/**
 * TokenSparkline displays a sparkline graph for a token
 * Uses cached Supabase storage with fallback to CoinGecko
 */
const TokenSparkline = ({ coingeckoId, tokenName, className = 'w-24 h-6' }) => {
  const [graphError, setGraphError] = useState(false);

  if (!coingeckoId) {
    return <span className="text-gray-400 text-xs">—</span>;
  }

  // Calculate graphUrl - use cached version from Supabase storage, fallback to CoinGecko
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const cachedGraphUrl = supabaseUrl
    ? `${supabaseUrl}/storage/v1/object/public/graphs/sparklines/${coingeckoId}.svg`
    : null;
  const fallbackGraphUrl = `https://data.coingecko.com/coins/${coingeckoId}/sparkline.svg`;

  // Use cached URL unless there was an error, then use fallback
  const graphUrl = !graphError && cachedGraphUrl ? cachedGraphUrl : fallbackGraphUrl;

  return (
    <img
      src={graphUrl}
      alt={`${tokenName || 'Token'} price graph`}
      className={`${className} rounded`}
      onError={() => setGraphError(true)}
    />
  );
};

export default TokenSparkline;
